export default "__VITE_ASSET__Dl_2Rpp1__"